import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Component } from 'react';
import isEqual from 'lodash/isEqual';
import { createNode } from 'yaml';
import { getLocalText } from '@/utilities/language';
import { getRealShowOption, inputChecker, resetAnwsers } from '@/utilities/quest';
import { randomArray, randomComp, randomShowOptions } from '@/utilities/common';
var defaultAnswer = {
  selected: [],
  text: '',
  type: 'single'
};
var SingleChoice = /*#__PURE__*/function (_Component) {
  _inherits(SingleChoice, _Component);
  function SingleChoice(props) {
    var _this;
    _classCallCheck(this, SingleChoice);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(SingleChoice).call(this, props));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "validator", function (rules, answer, callback) {
      var _this$props = _this.props,
        question = _this$props.question,
        quotaStrategy = _this$props.quotaStrategy;
      var disabledOpts = quotaStrategy === null || quotaStrategy === void 0 ? void 0 : quotaStrategy.optionsQuota.filter(function (q) {
        return !q.remaining;
      });
      var type = question.type;
      var realShowOptions = _this.state.realShowOptions;
      if ((disabledOpts === null || disabledOpts === void 0 ? void 0 : disabledOpts.length) === realShowOptions.length && question.required) {
        _this.setState({
          errorOption: ''
        });
        callback();
        return; // 全部选项满额的时候就不检查了
      }

      if (question.required && answer.selected.length === 0) {
        _this.setState({
          errorOption: ''
        });
        callback(getLocalText('SingleChoice.Selected'));
        return;
      }
      var otherRequired = question.custom.other.status === 2;
      var otherChecked = answer.selected.includes('other');
      var textRequired = otherRequired && otherChecked;
      if (textRequired && !answer.text) {
        _this.setState({
          errorOption: 'other'
        });
        callback(getLocalText('SingleChoice.otherText'));
        return;
      }
      var optionBlank = answer.option_blank || {};
      var selectedOption = realShowOptions.find(function (el) {
        return el.id === answer.selected[0];
      });
      if ((type === 'single' || type === 'nonScoreSingle') && selectedOption && selectedOption.input === 'required') {
        try {
          if (!answer.option_blank[selectedOption.id][0]) {
            _this.setState({
              errorOption: selectedOption.id
            });
            callback(getLocalText('SingleChoice.Selected'));
            return;
          }
        } catch (error) {
          _this.setState({
            errorOption: selectedOption.id
          });
          callback(getLocalText('SingleChoice.Selected'));
          return;
        }
      }
      if ((type === 'single' || type === 'nonScoreSingle') && selectedOption && !!selectedOption.input && (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption[window.showMultiLang ? "".concat(window.language, "Restrictions") : 'restrictions']) && optionBlank[selectedOption.id]) {
        var result = inputChecker(answer.option_blank[selectedOption.id][0], selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption[window.showMultiLang ? "".concat(window.language, "Restrictions") : 'restrictions']);
        if (result !== true) {
          _this.setState({
            errorOption: selectedOption.id
          });
          callback(result);
          return;
        }
      }
      _this.setState({
        errorOption: ''
      });
      callback();
    });
    var _props$question = props.question,
      _question = _props$question === void 0 ? {} : _props$question,
      answers = props.answers,
      _quotaStrategy = props.quotaStrategy;
    var custom = _question.custom;
    _this.state = {
      options: (custom || {}).options || [],
      errorOption: '',
      realShowOptions: getRealShowOption({
        question: _question,
        answers: answers,
        quotaStrategy: _quotaStrategy
      }),
      realShowOptionsBack: getRealShowOption({
        question: _question,
        answers: answers,
        quotaStrategy: _quotaStrategy
      }),
      setShowOptions: (custom.random || custom.reverse) && custom.showOptionsNum && custom.showOptionsNum > 0
    };
    if (custom.random || custom.reverse) {
      if (custom.random) {
        // 随机排序
        _this.state.realShowOptions = randomArray(_toConsumableArray(_this.state.realShowOptions));
      } else if (custom.reverse) {
        var actuallyReverse = Math.random() >= 0.5;
        if (actuallyReverse) {
          _this.state.realShowOptions = randomArray(_toConsumableArray(_this.state.realShowOptions), 'reverse');
        }
      }
      if (_this.state.setShowOptions) {
        _this.state.realShowOptions = randomShowOptions(_toConsumableArray(_this.state.realShowOptions), custom.showOptionsNum, custom.random ? 'random' : 'reverse');
        props.form.setFieldsValue(_defineProperty({}, _question.id, {
          type: _question.type,
          selected: [],
          text: ''
        }));
      }
    }
    return _this;
  }
  _createClass(SingleChoice, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
        question = _this$props2.question,
        answers = _this$props2.answers;
      try {
        var _answers$question$id, _answers$question$id2;
        var selected = (answers === null || answers === void 0 ? void 0 : (_answers$question$id = answers[question.id]) === null || _answers$question$id === void 0 ? void 0 : _answers$question$id.selected) || [];
        var option_blank = (answers === null || answers === void 0 ? void 0 : (_answers$question$id2 = answers[question.id]) === null || _answers$question$id2 === void 0 ? void 0 : _answers$question$id2.option_blank) || {};
        var realShowOptions = this.state.realShowOptions;
        if (selected.length) {
          var newSelected = resetAnwsers({
            type: question.type,
            question: question,
            answers: answers,
            realShowOptions: realShowOptions
          });
          Object.keys(option_blank).forEach(function (key) {
            if (!newSelected.includes(key)) {
              delete option_blank[key];
            }
          });
          this.props.form.setFieldsValue(_defineProperty({}, question.id, {
            type: question.type,
            selected: newSelected,
            option_blank: option_blank,
            text: ''
          }));
        }
      } catch (error) {
        console.error(error);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var prevQ = prevProps.question;
      var nextQ = this.props.question;
      if (nextQ.optionFilter && nextQ.optionFilter[0] && !window.isReport) {
        var _nextQ$optionFilter$ = nextQ.optionFilter[0].id.split('--matrix--'),
          _nextQ$optionFilter$2 = _slicedToArray(_nextQ$optionFilter$, 2),
          filterByQuestionId = _nextQ$optionFilter$2[0],
          lineId = _nextQ$optionFilter$2[1];
        var nowAnswers = this.props.answers;
        var prevAnswers = prevProps.answers;
        var nowThatQuestionSelectedOptionsIds = nowAnswers[filterByQuestionId] ? nowAnswers[filterByQuestionId].selected : [];
        var prevThatQuestionSelectedOptionsIds = prevAnswers[filterByQuestionId] ? prevAnswers[filterByQuestionId].selected : [];
        if (lineId) {
          if (lineId.indexOf('title') > -1) {
            lineId = lineId.slice(0, -6);
          }
          nowThatQuestionSelectedOptionsIds = nowThatQuestionSelectedOptionsIds[lineId] || [];
          prevThatQuestionSelectedOptionsIds = prevThatQuestionSelectedOptionsIds[lineId] || [];
        }
        var equal = isEqual(nowThatQuestionSelectedOptionsIds.sort(), prevThatQuestionSelectedOptionsIds.sort());
        if (!equal && !(nowThatQuestionSelectedOptionsIds.length === 0 && prevThatQuestionSelectedOptionsIds.length === 0)) {
          this.props.form.setFieldsValue(_defineProperty({}, nextQ.id, {
            type: nextQ.type,
            selected: [],
            text: ''
          }));
        }
      }

      // 如果选项变了 就清空答案
      if (prevState.realShowOptions !== this.state.realShowOptions && !window.isReport) {
        this.props.form.setFieldsValue(_defineProperty({}, nextQ.id, {
          type: nextQ.type,
          selected: [],
          text: ''
        }));
      }

      // 预览模式下面始终不成立（broadcastchannel 使用JSON.stringify传递数据
      // 问卷模式下面始终成立， 问卷结构不会改变
      if (prevQ === nextQ) return;
      // 打开随机按钮
      if (!prevQ.custom.random && nextQ.custom.random) {
        // eslint-disable-next-line
        this.setState({
          options: nextQ.custom.options.slice().sort(randomComp)
        });
      }
      // 关闭随机按钮
      if (prevQ.custom.random && !nextQ.custom.random) {
        // eslint-disable-next-line
        this.setState({
          options: nextQ.custom.options
        });
      }
      // 判断是否修改了options， 但是broadcast channel始终是深拷贝传递。所以这里不能比较地址了。
      if (JSON.stringify(nextQ.custom.options) !== JSON.stringify(prevQ.custom.options)) {
        if (nextQ.custom.random) {
          // eslint-disable-next-line
          this.setState({
            options: nextQ.custom.options.slice().sort(randomComp)
          });
        } else {
          // eslint-disable-next-line
          this.setState({
            options: nextQ.custom.options
          });
        }
      }
    }
  }, {
    key: "getSelectedChange",
    value: function getSelectedChange(id, answer) {
      var text = '';
      if (id === 'other') {
        text = answer && answer.text || '';
      }
      return {
        type: this.props.question.type,
        selected: id ? [id] : [],
        text: text,
        option_blank: _objectSpread({}, answer.option_blank)
      };
    }
  }, {
    key: "getInputChange",
    value: function getInputChange(id, input, answer) {
      var text = answer && answer.text || '';
      return {
        type: this.props.question.type,
        selected: [id],
        text: text,
        option_blank: _objectSpread({}, answer.option_blank, _defineProperty({}, id, [input]))
      };
    }
  }, {
    key: "getOtherTextChange",
    value: function getOtherTextChange(text) {
      return {
        type: this.props.question.type,
        selected: ['other'],
        text: text
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        question = _this$props3.question,
        _this$props3$answer = _this$props3.answer,
        answer = _this$props3$answer === void 0 ? JSON.parse(JSON.stringify(defaultAnswer)) : _this$props3$answer,
        quotaStrategy = _this$props3.quotaStrategy;
      var realShowOptions = this.state.realShowOptions;
      var _this$props$form = this.props.form,
        getFieldProps = _this$props$form.getFieldProps,
        getFieldError = _this$props$form.getFieldError;
      var id = question.id || 'unknown-form-item';
      var _getFieldProps = getFieldProps(id, {
          initialValue: answer,
          rules: [{
            validator: this.validator
          }]
        }),
        onChange = _getFieldProps.onChange,
        formAnswer = _getFieldProps.value; // 因为getFieldError无法判断error的来源，所以只能用这样的trick方法，
      // rc-form 写的真心不好
      var errorSelected;
      var errorText;
      var error = getFieldError(id);
      if (error && error[0]) {
        var _error = _slicedToArray(error, 1);
        errorSelected = _error[0];
      }
      if (error && error[0] === getLocalText('SingleChoice.otherText')) {
        var _error2 = _slicedToArray(error, 1);
        errorText = _error2[0];
      }
      var disabledOptIds = (quotaStrategy === null || quotaStrategy === void 0 ? void 0 : quotaStrategy.optionsQuota.filter(function (q) {
        return !q.remaining;
      }).map(function (q) {
        return q.id;
      })) || [];
      var params = {
        options: realShowOptions,
        formAnswer: formAnswer,
        error: {
          selected: errorSelected,
          text: errorText,
          errorOption: this.state.errorOption
        },
        onChange: {
          selected: function selected(_selected) {
            return onChange(_this2.getSelectedChange(_selected, formAnswer));
          },
          text: function text(_text) {
            return onChange(_this2.getOtherTextChange(_text));
          },
          input: function input(id, _input) {
            onChange(_this2.getInputChange(id, _input, formAnswer));
          }
        },
        disabledOptIds: disabledOptIds
      };
      return this.props.children(params);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps, state) {
      var question = nextProps.question,
        answers = nextProps.answers,
        quotaStrategy = nextProps.quotaStrategy;
      var custom = question.custom;
      var realShowOptions = getRealShowOption({
        question: question,
        answers: answers,
        quotaStrategy: quotaStrategy
      });
      window.allQuestions.find(function (el) {
        return el.id === question.id;
      }).custom.realShowOptions = realShowOptions;
      if (custom.random) {
        realShowOptions = randomArray(_toConsumableArray(realShowOptions));
      }
      if (realShowOptions.length !== state.realShowOptionsBack.length || realShowOptions.some(function (el) {
        return !state.realShowOptionsBack.find(function (item) {
          return item.id === el.id;
        });
      }) || realShowOptions.some(function (el) {
        return el.text !== state.realShowOptionsBack.find(function (item) {
          return item.id === el.id;
        }).text;
      })) {
        var realShowOptionsBack = _toConsumableArray(realShowOptions);
        if (custom.random) {
          realShowOptions = randomArray(_toConsumableArray(realShowOptions));
        }
        if ((custom.random || custom.reverse) && state.setShowOptions) {
          realShowOptions = randomShowOptions(_toConsumableArray(realShowOptions), custom.showOptionsNum, custom.random ? 'random' : 'reverse');
          nextProps.form.setFieldsValue(_defineProperty({}, question.id, {
            type: question.type,
            selected: [],
            text: ''
          }));
        }
        return {
          realShowOptions: realShowOptions,
          realShowOptionsBack: realShowOptionsBack
        };
      }
      return null;
    }
  }]);
  return SingleChoice;
}(Component);
export { SingleChoice as default };